// @ts-strict-ignore
import clsx from 'clsx'
import { FC, useState } from 'react'

import { RegionModalContent } from '@/widgets/RegionSelector/ui/RegionModalContent/RegionModalContent'

import { Button, Modal } from '@/shared/ui'

import styles from './OpenRegionNavButton.module.scss'

export type ButtonProps = {
	big?: boolean
	children?: JSX.Element | string
	className?: string
}

export const OpenRegionNavButton: FC<ButtonProps> = ({ children, className = '' }: ButtonProps) => {
	const [isOpen, setIsOpen] = useState(false)

	const openModal = () => setIsOpen(true)
	const closeModal = () => {
		setIsOpen(false)
		document.body.style.overflow = 'unset'
	}

	return (
		<>
			<Button theme="link" type="button" className={clsx(styles.button, className)} onClick={openModal}>
				{children}
			</Button>
			<Modal fullScreenOnMobile isOpen={isOpen} onClose={closeModal}>
				<RegionModalContent />
			</Modal>
		</>
	)
}
